import React from "react";
import { Form, Flex, Input } from "antd";
import { OTPProps } from "antd/es/input/OTP";

import { _isLengthEqual, _isNumber, _isRequired } from "utils/form/simple-validation";
import { FORM_VALIDATION_DEBOUNCE } from "constants/form";

interface IOtpInputProps extends Omit<OTPProps, "onChange" | "onFinish"> {
  className?: string;
  onSendSms: () => void;
  loading?: boolean;
  name?: string;
  additionalButtons?: React.ReactNode;
  length?: number;
  onComplete?: (value: string) => void;
  value?: string;
  onChange?: (value: string) => void;
  error?: string;
}

export const OtpInput: React.FC<IOtpInputProps> = ({
  className,
  onSendSms,
  loading = false,
  name = "otp",
  additionalButtons,
  length = 4,
  disabled = false,
  onComplete,
  value,
  onChange,
  error,
  ...otpProps
}) => {
  const form = Form.useFormInstance();
  const isError = error === "Неверный код";

  return (
    <Flex vertical align="center">
      <Form.Item
        name={name}
        rules={[
          _isRequired("Код обязателен для ввода"),
          _isNumber("Код должен содержать только цифры"),
          _isLengthEqual(length),
        ]}
        validateDebounce={FORM_VALIDATION_DEBOUNCE}
        className={`${className ?? "margin-none"} text-center`}
        validateTrigger={["onChange", "onInput"]}
        validateStatus={isError ? "error" : undefined}
        help={isError ? error : undefined}
      >
        <Input.OTP
          length={length}
          disabled={disabled}
          {...otpProps}
          size="large"
          formatter={(str) => str.replace(/\D/g, "")}
          autoFocus
          value={value}
          status={isError ? "error" : undefined}
          onChange={(newValue) => {
            const normalizedValue = newValue || "";

            if (form) {
              form.setFieldsValue({ [name]: normalizedValue });
            }

            if (onChange) {
              onChange(normalizedValue);
            }
          }}
          onInput={(values) => {
            if (Array.isArray(values)) {
              const joinedValue = values.join("");

              if (form) {
                form.setFieldsValue({ [name]: joinedValue });
              }

              if (onChange) {
                onChange(joinedValue);
              }

              if (onComplete && joinedValue && joinedValue.length === length) {
                onComplete(joinedValue);
              }
            }
          }}
        />
      </Form.Item>

      {additionalButtons}
    </Flex>
  );
};
